export const environment = {
  production: false,
  apiUrl: 'https://giocalendario-api-test.simonelambiase.it/api',
  apiVersion: 'v1',
  appVersion: '1.2.1-SNAPSHOT',
  sentryDsn: 'https://53a225b453b2ba7e52f2c968362fa5bf@o4512208282714112.ingest.de.sentry.io/4512208376430672',
  sentryEnvironment: 'test'
};
